import { EnvironmentService } from '@angular-monorepo/environment';
import { Injectable, WritableSignal, computed, signal } from '@angular/core';
import { GetPaymentPayloadRequest, GetPaymentResponseRequest } from './cash-processor.interface';
import { buildMockCashProcessorPayment } from './cash-processor.mock';
import { catchError, delay, of, take, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { State } from '@core/models/state.interface';

@Injectable({
  providedIn: 'root'
})
export class CashProcessorService {
  #getPaymentData: WritableSignal<State<GetPaymentResponseRequest>> = signal<State<GetPaymentResponseRequest>>({ data: {} as GetPaymentResponseRequest, loading: false })

  public paymentData = computed(() => this.#getPaymentData().data)
  public paymentLoading = computed(() => this.#getPaymentData().loading)
  public getPaymentError = computed(() => this.#getPaymentData().error)

  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
  ) { }

  getPayment(data: GetPaymentPayloadRequest): void {
    this.#getPaymentData.update((state) => ({ ...state, loading: true, error: undefined }));

    const request$ = this.shouldUseMock()
      ? of(buildMockCashProcessorPayment(String(data.operationId), String(data.merchantId))).pipe(delay(300))
      : this.http.get<GetPaymentResponseRequest>(
          `${this.environmentService?.env?.apiConfig?.cashProcessorUrl}/${data.merchantId}/${data.operationId}?verification=${data.verification}`,
        );

    request$
      .pipe(
        take(1),
        tap((response: GetPaymentResponseRequest) => {
          this.#getPaymentData.set({ data: response, loading: false });
        }),
        catchError((error) => {
          this.#getPaymentData.update((state) => ({
            ...state,
            loading: false,
            error,
          }));
          throw error;
        }),
      )
      .subscribe();
  }

  private shouldUseMock(): boolean {
    return !!this.environmentService?.env?.useCashProcessorMock;
  }

  goToWebsiteUrl(operationId: string) {
    const id = btoa(operationId);
    const url: any = `${this.environmentService?.env?.apiConfig?.payinCheckoutBackendUrl}common/redirect/backward-transaction/${id}`;
    window.location = url;
  }

  getOTP(operationId: number) {
    return this.http.post<any>(`${this.environmentService?.env?.apiConfig?.payinCheckoutBackendUrl}processor/deuna/generate-otp`, { operationId })
  }

}
